/**
 * LeadsFilter component - filters for marketing leads
 */

import { useEffect, useState } from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';
import type { LeadsSummary } from '../../services/marketingApi';

interface LeadsFilterProps {
  serviceTypes: LeadsSummary[];
  selectedServiceType: string;
  daysSinceService: number;
  onServiceTypeChange: (value: string) => void;
  onDaysSinceChange: (value: number) => void;
  isLoading?: boolean;
}

export function LeadsFilter({
  serviceTypes,
  selectedServiceType,
  daysSinceService,
  onServiceTypeChange,
  onDaysSinceChange,
  isLoading,
}: LeadsFilterProps) {
  const [daysInput, setDaysInput] = useState(daysSinceService.toString());

  useEffect(() => {
    setDaysInput(daysSinceService.toString());
  }, [daysSinceService]);

  const handleDaysBlur = () => {
    const parsed = parseInt(daysInput, 10);
    if (!isNaN(parsed) && parsed > 0) {
      onDaysSinceChange(parsed);
    } else {
      setDaysInput(daysSinceService.toString());
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 p-4 bg-muted/50 rounded-lg">
      <div className="flex-1 space-y-2">
        <Label htmlFor="service-type">Tipo de servicio</Label>
        <Select
          value={selectedServiceType}
          onValueChange={onServiceTypeChange}
          disabled={isLoading}
        >
          <SelectTrigger id="service-type">
            <SelectValue placeholder="Seleccionar tipo de servicio" />
          </SelectTrigger>
          <SelectContent>
            {serviceTypes.map((st) => (
              <SelectItem key={st.service_type.id} value={st.service_type.id}>
                {st.service_type.name} ({st.leads_count} leads)
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="w-full sm:w-48 space-y-2">
        <Label htmlFor="days-since">Días desde último servicio</Label>
        <Input
          id="days-since"
          type="number"
          min={1}
          value={daysInput}
          onChange={(e) => setDaysInput(e.target.value)}
          onBlur={handleDaysBlur}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleDaysBlur();
            }
          }}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
